// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".subtitle-2 div[data-v-63e55034]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.griditemimg[data-v-63e55034]{height:270px}@media screen and (min-width:1264px){.griditemimg[data-v-63e55034]{height:350px}}@media screen and (max-width:960px){.griditemimg[data-v-63e55034]{height:60vw}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
